import React from 'react' 
import AppAddTxtView from './app-app-txt-view'

const AppAddTxt:React.FC = ()=>{
    return <AppAddTxtView/>
}

export default AppAddTxt ;
